module.exports = __webpack_public_path__ + "img/logo beta.fb0962e4.svg";